/** COPYRIGHT NOTICE
 *
 *  Copyright (C) Vokke.
 *  All Rights Reserved
 *
 *  This file was developed by Vokke and is only to be used by a person or legal
 *  entity when expressly granted a license to do so through written means.
 *
 *  Unauthorized usage, sharing or copying of this file, via any medium is
 *  strictly prohibited. Proprietary and confidential. This license header
 *  is not to be removed.
 *
 */

/**
 *  The following class is to be extended by all routes. The kernel expects
 *  that all routes will extend this class, and that all child classes of
 *  this class are indeed routes.
 *
 *  @author A. I. Grayson-Widarsito
 */
export class KernelRoute {

    /**
     *  Binds a URI resource ("/tickets") to a local method ("getTickets()"). You must
     *  pass the method name, not a function.
     *
     * @param endpoint
     * @param method
     */
    addRoute (endpoint, method) {
        this.routeBindings = this.routeBindings || {};
        this.routeBindings[endpoint] = method;
    }

    /**
     *  Returns a key/value object. The key is the endpoint, the value is the
     *  local name of the method.
     *
     * @returns {*}
     */
    getRoutes () {
        this.routeBindings = this.routeBindings || {};
        return this.routeBindings;
    }

}

/**
 *  KernelRouteEndpoint is a decorator which can be used on route methods inside
 *  KernelRoute instances. This is a shortcut instead of using the addRoute method.
 *
 * @author A. I. Grayson-Widarsito
 * @param route
 * @returns {Function}
 * @constructor
 */
export function KernelRouteEndpoint(route) {
    return function(target, name, descriptor) {
        if ("function" !== typeof target.addRoute) {
            throw new Error("Method addRoute not found not class. Is the class extending KernelRoute?");
        }

        /** Remove the leading slash if present; it won't work if one is there **/
        target.addRoute(route.replace(/^\/|\/$/g, ""), name);
        return descriptor;
    }
}


// WEBPACK FOOTER //
// ./public/kernel/abstraction/routing.js